import styled from 'styled-components';
import { standardChartColors } from 'ui/theme';
import { Cell } from './Cell';

const StyledCell = styled(Cell)`
  && {
    width: fit-content;
    padding-right: 0;
  }
`;

const Icon = styled.div<{ $color: string }>`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
`;

type ColorIconCellProps = {
  rowIndex: number;
  isEnabled?: boolean;
};

export const DATA_TEST = {
  cell: 'color-cell',
  icon: 'color-icon',
};

export const ColorIconCell = ({ rowIndex, isEnabled }: ColorIconCellProps) => {
  const colors = Object.values(standardChartColors);
  if (!isEnabled) return null;

  return (
    <StyledCell data-test={DATA_TEST.cell} columnId="icon" $rowIndex={rowIndex}>
      <Icon data-test={`${DATA_TEST.icon}-${colors[rowIndex]}`} $color={colors[rowIndex]} />
    </StyledCell>
  );
};
